import {Component, Input, OnInit} from '@angular/core';
import {Host} from "../../../../common";

@Component({
  selector: 'time-zone-warning',
  standalone: false,
  template: `
    <div class="mt-3 alert alert-warning" role="alert" *ngIf="show">
      <i class="fas fa-exclamation-triangle"></i>&nbsp;
      <span i18n>You seem to be ordering from a different time zone than the host. All times are given in the local time zone of the host, {{ host_tz }}.</span>
    </div>
  `
})

export class TimeZoneWarning implements OnInit {
  @Input() host: Host;

  show: boolean;
  host_tz: string;
  client_tz: string;

  ngOnInit(): void {
    this.host_tz = this.host.timezone;
    this.client_tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (this.client_tz === undefined) {
      // IE11 doesn't support that
      this.show = false;
    } else {
      this.show = (this.client_tz != this.host_tz);
    }
  }
}
